import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    user: null,
    sessionToken: null,
    // 经销商
    dealer: null,
    // 水机
    machine: null,
    // 项目
    appproject: null,
    adminProject: null,
    // 设备状态
    status: null
  },
  getters: {
  },
  mutations: {
    initFromStorage (state, opt) {
      for (let i in opt) {
        state[i] = opt[i]
      }
    },
    setUser (state, opt) {
      state.user = opt
    },
    setSessionToken (state, opt) {
      state.sessionToken = opt
    },
    setDealer (state, opt) {
      state.dealer = opt
    },
    setMachine (state, opt) {
      state.machine = opt
    },
    setProject (state, opt) {
      state.appproject = opt
    },
    changeUser (state, opt) {
      state.user[opt.key] = opt.val
    },
    setStatus (state, opt) {
      state.status = opt
    },
    logout (state) {
      state.user = null
      state.sessionToken = null
    }
  },
  actions: {}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js